export default __webpack_public_path__ + "static/media/Moon 1.d0ae79e9.png";